(function() {
'use strict';

angular.module('TR')
    .directive('rating', rating);

function rating() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            stars: '@',
            full: '='
        },
        template: '<span class="star-rating">' +
                    '<i ng-repeat="starClass in rating track by $index" class="{{starClass}}" />' +
                  '</span>',

        link(scope) {
            const starsNumber = parseFloat(scope.stars);
            const hasHalf = starsNumber - _.floor(starsNumber) > 0;
            scope.rating = _.map(
                new Array(5),
                (v, idx) => {
                    const currentStar = idx + 1;
                    if (currentStar <= starsNumber) { return 'icon-star'; }
                    if (hasHalf) { return 'icon-star half'; }
                    if (scope.full) { return 'icon-star greyed'; }
                }
            );
        }

    };
}
})();
